/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartBarsXUpIcon20Light = forwardRef('DataChartBarsXUpIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M15.5 3a.5.5 0 0 1 .5.5v10.719a.5.5 0 0 1-1 0V3.5a.5.5 0 0 1 .5-.5Z" }),
        React.createElement("path", { d: "M12 6a.5.5 0 0 0-1 0v8.219a.5.5 0 0 0 1 0V6Z" }),
        React.createElement("path", { d: "M3.5 10.25a.5.5 0 0 1 .5.5v3.5a.5.5 0 0 1-1 0v-3.5a.5.5 0 0 1 .5-.5Z" }),
        React.createElement("path", { d: "M1 17.5a.5.5 0 0 1 .5-.5h16a.5.5 0 0 1 0 1h-16a.5.5 0 0 1-.5-.5Z" }),
        React.createElement("path", { d: "M8 8.35a.5.5 0 0 0-1 0v5.869a.5.5 0 0 0 1 0V8.35Z" })));
});
